<template lang="pug">
  router-view(
    v-bind:sideNavData="sideNavData"
  )
</template>
<script>
export default {
  name: "ProfilePage",
  data() {
    return {
      sideNavData: {
        links: [
          {
            path: "/pages/profile/",
            text: "Профиль"
          },
          {
            path: "/pages/profile/my-childs",
            text: "Мои дети"
          },
          {
            path: "/pages/profile/requests",
            text: "Заявки"
          },
          {
            path: "/pages/profile/settings/",
            text: "Настройки аккаунта"
          }
        ]
      }
    };
  }
};
</script>
<style lang="scss" scoped></style>
